import {Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {HomeAddressOverridePopoverController} from './HomeAddressOverridePopoverController';
import {BasePopoverContentsComponent} from '../../../../../../BaseUI/BasePopoverContentsComponent';
import {UserDeliveryAddressDTOInterface} from '../../../../../../../DTO/UserDeliveryAddressDTOInterface';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './HomeAddressOverridePopoverComponent.html',
	styleUrls: ['./HomeAddressOverridePopoverComponent.scss'],
})

export class HomeAddressOverridePopoverComponent extends BasePopoverContentsComponent {
	// コンポーネントを操作するコントローラー
	public combineCtrl: HomeAddressOverridePopoverController;

	// 自分自身のコンポーネント名称
	public componentName = 'HomeAddressOverridePopoverComponent';

	/**
	 *
	 * @param dialogRef
	 * @param dialogCtrl
	 * @param data
	 */
	constructor(
		public dialogRef: MatDialogRef<HomeAddressOverridePopoverComponent>, //自分の参照。これにcloseしてもいい
		public dialogCtrl: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: {
			userDeliveryAddress: UserDeliveryAddressDTOInterface;//新たに登録する住所
			primaryAddress: UserDeliveryAddressDTOInterface;//登録済みの住所
			registerAddress: (data: UserDeliveryAddressDTOInterface) => void;
			close: () => void;
			refresh: () => void;
		} // 呼び出し側から受け取るデータ
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();
		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(HomeAddressOverridePopoverController);
	}

	/**
	 * start
	 * 開始処理
	 */
	public async start() {
		this.log(this.data);
	}

	public async onClickHome(): Promise<void> {
		await this.data.registerAddress(this.data.userDeliveryAddress);
		await this.onClickClosePanel();

	}

	public async onClickOther(): Promise<void> {
		this.data.userDeliveryAddress.type = 'OTHER';
		await this.data.registerAddress(this.data.userDeliveryAddress);
		await this.onClickClosePanel();
	}

	/**
	 * onClickClosePanel
	 * パネルを閉じたときの処理
	 */
	public async onClickClosePanel() {
		this.data.close();
	}

}
